import membershipStatuses from './constants/membershipStatuses';

const AccountSideNavLinkBuilderComponent = {
  name: '_AccountSideNavLink_',
  inputs: [
    {
      name: 'linkText',
      friendlyName: 'Link Text',
      helperText: 'The text displayed as the link.',
      type: 'string',
      defaultValue: 'New Arrivals',
      localized: true,
      required: true,
    },
    {
      name: 'linkUrl',
      friendlyName: 'Link URL',
      helperText:
        'Only include URL slug. Example: /collections/womens-new-arrivals',
      type: 'string',
      defaultValue: '/',
      localized: true,
      required: true,
    },
    {
      name: 'dataAnalytics',
      friendlyName: 'Data Analytics',
      type: 'object',
      subFields: [
        {
          name: 'label',
          friendlyName: 'Analytics Label',
          helperText:
            'Label provided through to analytics services. Example: T2_Men_Bottoms',
          type: 'string',
          required: true,
          localized: false,
        },
        {
          name: 'category',
          friendlyName: 'Analytics Category',
          helperText:
            'Category provided through to analytics services. Example: navigation',
          type: 'string',
          required: true,
          localized: false,
        },
      ],
    },
    {
      name: 'membershipStatusList',
      type: 'Tags',
      helperText:
        'Optional membership status required to view this link. If not set, the link will be visible to all users.',
      enum: membershipStatuses,
    },
  ],
} as const;

export default AccountSideNavLinkBuilderComponent;
